<div class="bm--hover-effect" (click)="playTrack($event, track)">
  <img loading="lazy" src="{{ track?.images?.middle }}" alt="track cover" />

  <!-- Play button shown on hover -->
  <div
    class="common-track-cover__play-icon"
    [ngClass]="{ 'common-hide-play-icon': track?.id === player.currentTrack?.id }"
  >
    <button class="common-play-pause-btn common-play-pause-btn--box btv-icon-play" aria-label="play"></button>
  </div>

  <!-- Active track -->
  @if (player?.currentTrack?.id === track?.id && player.status === PlayStatus.Playing) {
    <div class="common-track-cover__pause-icon">
      <button class="common-play-pause-btn common-play-pause-btn--box btv-icon-pause" aria-label="pause"></button>
    </div>
  }
</div>
